import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from '@apollo/client/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataRequest } from '@tiltgroup/web-components';
import { CarrierPaginator, Query, QueryCarriersArgs } from '@graphql-types';
import { QueriesBaseService } from '@services/queries/queries-base.service';
import { carriersQuery } from '@services/queries/queries/carriers.queries';

@Injectable({
  providedIn: 'root',
})
export class CarriersQueriesService extends QueriesBaseService {
  private _apollo = inject(Apollo);

  getCarriers(
    request: DataRequest<QueryCarriersArgs>
  ): Observable<CarrierPaginator> {
    const { page, size, where, sort } = request;

    return this._apollo
      .query({
        query: carriersQuery,
        variables: {
          page,
          size,
          where,
          ...(sort && { orderBy: this.orderBy(sort) }),
        },
      })
      .pipe(map((res: ApolloQueryResult<Query>) => res?.data?.carriers));
  }
}
